import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import { EActionType } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

interface ICallButton {
  actionType: EActionType;
  fullWidth?: boolean;
  onClick(): void;
  phones: string[];
}

export const CallButton = ({ onClick, phones, actionType, fullWidth }: ICallButton) => {
  return (
    <Button data-actionType={actionType} onClick={onClick} fullWidth={fullWidth}>
      {formatPhoneNumber(phones[0]).slice(0, -3)}...
    </Button>
  );
};
